export const getEnvConfig = (key) => {
    return window.ENV?.[key] || process.env[key];
};